import { combineReducers } from 'redux'
import {VIEW_APPLICATION_DATA,APPLICATION_STATUS,VIEW_COHORT_APPLICATION_DATA } from '../../../../../common/constants/actionConstants'

const getViewApplicationCohort = (state = [], action) => {
  switch (action.type) {
    case VIEW_COHORT_APPLICATION_DATA:
      return { ...action.payload }
    default:
      return state
  }
}

  const getViewApplicationData = (state = [], action) => {
    switch (action.type) {
      case VIEW_APPLICATION_DATA:
        return { ...action.payload }
      default:
        return state
    }
  }
  
  const updateApplicationStatus = (state = [], action) => {
    switch (action.type) {
      case APPLICATION_STATUS:
        return { ...action.payload }
      default:
        return state
    }
  }
  

  const AdminMentorViewReducer = combineReducers({
    getViewApplicationData,
    updateApplicationStatus,
    getViewApplicationCohort
  })
  
  export default AdminMentorViewReducer
  